<template>
  <component :is="tncComponent" />
</template>

<script>
import { mapGetters } from 'vuex';
import TNCEn from '@/components/menus/tnc/tnc-en.vue';
import TNCVn from '@/components/menus/tnc/tnc-vn.vue';
import TNCId from '@/components/menus/tnc/tnc-id.vue';
import TNCTh from '@/components/menus/tnc/tnc-th.vue';
import TNCZh from '@/components/menus/tnc/tnc-zh.vue';
import TNCKh from '@/components/menus/tnc/tnc-kh.vue';
import TNCEs from '@/components/menus/tnc/tnc-es.vue';
import TNCPk from '@/components/menus/tnc/tnc-pk.vue';
import TNCJp from '@/components/menus/tnc/tnc-jp.vue';
import TNCKr from '@/components/menus/tnc/tnc-kr.vue';
import TNCMm from '@/components/menus/tnc/tnc-mm.vue';
import TNCBd from '@/components/menus/tnc/tnc-bd.vue';
import TNCHant from '@/components/menus/tnc/tnc-hant.vue';
import TNCIn from '@/components/menus/tnc/tnc-in.vue';
import TNCPt from '@/components/menus/tnc/tnc-pt.vue';
import TNCUz from '@/components/menus/tnc/tnc-uz.vue';
export default {
  computed: {
    ...mapGetters('general', ['config']),
    tncComponent() {
      switch (this.config.language) {
        case 'en':
          return TNCEn;
        case 'th':
          return TNCTh;
        case 'id':
          return TNCId;
        case 'vn':
          return TNCVn;
        case 'zh':
          return TNCZh;
        case 'es':
          return TNCEs;
        case 'pk':
          return TNCPk;
        case 'jp':
          return TNCJp;
        case 'kr':
          return TNCKr;
        case 'mm':
          return TNCMm;
        case 'bd':
          return TNCBd;
        case 'hant':
          return TNCHant;
        case 'in':
          return TNCIn;
        case 'kh':
          return TNCKh;
        case 'pt':
          return TNCPt;
        case 'uz':
          return TNCUz;
      }
    },
  },
};
</script>
